import { useQuery, useQueryClient } from '@tanstack/react-query';

import { useEffect } from 'react';
import { fetchMeetings } from '@/api/v4/meetings.api';
import { QueryKey } from '@/config/query-client';
import { reorderMeetings } from '@/features/action-panel/meetings/helpers/reorder-meetings';
import { editedMeetingIdState } from '@/features/action-panel/meetings/meetings.state';

import { teamIdState } from '../../../team.state';
import { useAtomValue } from 'jotai';

export const useTeamMeetings = () => {
  const queryClient = useQueryClient();
  const teamId = useAtomValue(teamIdState);
  const editedMeetingId = useAtomValue(editedMeetingIdState);

  const fetchTeamMeetings = async () => {
    if (!teamId) return [];

    return fetchMeetings({ teamId });
  };

  const query = useQuery({
    queryKey: [QueryKey.TeamMeetings, teamId],
    queryFn: fetchTeamMeetings,
    select: meetings =>
      editedMeetingId ? reorderMeetings(meetings, editedMeetingId) : meetings,
    enabled: !!teamId,
    staleTime: 1000 * 60 * 5,
  });

  useEffect(() => {
    if (query.data) {
      void queryClient.invalidateQueries({
        queryKey: [QueryKey.TeamActionsInfo, teamId],
      });
    }
  }, [query.data, queryClient, teamId]);

  return query;
};
